<template>
    <form class="forms__form" @submit.prevent="submit">
        <UiValidationErrors />
        <fieldset class="forms__fieldset">
            <legend hidden>General</legend>

            <Field v-model="form.name" :field="$page.props.fields.name" />
        </fieldset>

        <MountedTeleport to="#header-context-primary">
            <Button
                type="submit"
                :class="{ 'opacity-75': form.processing }"
                :loading="form.processing"
                :disabled="form.processing"
                dusk="form-submit"
                color="primary"
                @click="submit"
            >
                {{ lang('general.save') }}
            </Button>
        </MountedTeleport>

        <fieldset class="forms__actions">
            <div class="flex space-x-8">
                <div class="flex-auto text-center">
                    <Button
                        type="submit"
                        :class="{ 'opacity-75': form.processing }"
                        :loading="form.processing"
                        :disabled="form.processing"
                        dusk="form-submit"
                        color="primary"
                    >
                        {{ lang('general.save') }}
                    </Button>
                </div>
            </div>
        </fieldset>
    </form>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useForm } from '@inertiajs/vue3';
import { Attribute } from '@src/Products/Pages/types';

interface Props {
    object?: Attribute | null;
    prefix?: string | null;
    redirect?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
    object: null,
    prefix: null,
    redirect: null,
});

// eslint-disable-next-line
const isEdit = computed(() => (props.object && props.object.id) || false);

const form = useForm({
    id: props.object?.id,
    name: props.object?.name,
});

const submit = () => {
    if (form.id) {
        form.post(route(`${props.prefix}.admin.api.update`, { id: form.id, _method: 'PUT' }), {
            preserveScroll: true,
            preserveState: true,
            forceFormData: true,
            onSuccess: () => ({}),
            onStart: () => ({}),
            onFinish: () => ({}),
        });
    } else {
        form.post(
            route(`${props.prefix}.admin.api.create`, {
                redirect: props.redirect,
            }),
            {
                preserveScroll: true,
                preserveState: false,
                forceFormData: true,
                onSuccess: () => ({}),
                onStart: () => ({}),
                onFinish: () => ({}),
            },
        );
    }
};
</script>
